import { StyleProps, CSS } from "@shared/primitive-components"

export const contentContainer = (props: StyleProps): CSS => ({
  padding: props.theme.spacing(0, 10),
  flex: 1,
  flexDirection: `column`,
  justifyContent: `center`,
})

export const title = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(4),
  maxWidth: 370,
  lineHeight: props.theme.typography.body.lineHeight,
})

export const margin = (props: StyleProps) => ({
  margin: props.theme.spacing(5, 0),
})

export const buttonWrapper = (props: StyleProps): CSS => ({
  alignItems: `flex-end`,
  marginTop: props.theme.spacing(7),
  flexDirection: `column`,
})
